import { HTMLAttributes } from "react"
import { WorkspaceHomeLearnItem } from "../WorkspaceHomeLearnItem"
import * as Icons from "@nova/component-icons"
import { ButtonSecondary } from "@nova/component-btn"
import { WorkspaceHomeSectionTitle } from "../WorkspaceHomeSectionTitle"

export const WorkspaceHomeLearnSection = (rest: HTMLAttributes<HTMLDivElement>) => {
    return (
        <div {...rest}>
            <WorkspaceHomeSectionTitle className="mt-10" title="Learn how to use our platform" />

            <div className="flex flex-col gap-10">
                <WorkspaceHomeLearnItem
                    Icon={() => (
                        <Icons.ExtraLargeIcon
                            Icon={Icons.Concierge}
                            className="text-lazeryellow flex-shrink-0"
                        />
                    )}
                    title="Book a 1:1 Demo"
                    body="If you need more help or are curious on a deep dive into Nova's features, book a 1:1 demo. Our team would be happy to help."
                    Button={() => (
                        <ButtonSecondary
                            title="Book a Demo"
                            RightIcon={Icons.OpenInNew}
                            className="flex-shrink-0"
                            onClick={() =>
                                window.open(
                                    "https://www.mapnova.com/book-a-demo",
                                    "_blank",
                                    "noopener,noreferrer"
                                )
                            }
                        />
                    )}
                />

                <WorkspaceHomeLearnItem
                    Icon={() => (
                        <Icons.ExtraLargeIcon
                            Icon={Icons.LocalLibrary}
                            className="text-lazeryellow flex-shrink-0"
                        />
                    )}
                    title="Check out the Learn Center"
                    body="If it's your first time on Nova, or you have questions about using specific add-ons, the Learn Center is a great place to start."
                    Button={() => (
                        <ButtonSecondary
                            title="Learn Center"
                            RightIcon={Icons.OpenInNew}
                            className="flex-shrink-0"
                            onClick={() =>
                                window.open(
                                    "https://www.mapnova.com/learn/getting-started",
                                    "_blank",
                                    "noopener,noreferrer"
                                )
                            }
                        />
                    )}
                />
            </div>
        </div>
    )
}
